import { EntityBase } from "./EntityBase";
import { User } from "./User";
import { Utility } from "./Utility";

export abstract class Offer extends EntityBase {
    user: User = null!;
    utility: Utility = null!;
    price: number = null!;
    fee: number = null!;
    termFrom: Date = null!;
    termPeriod: number = null!;
    validDate: Date = null!;
    isNewRecord: boolean = null!;
    dateEntered: Date = null!;
    dateUpdated: Date = null!;

    abstract priceForBuyer(): number;

    abstract priceForSeller(): number;
}
